<form #f="ngForm" (keydown.enter)="(false)">
  <div fxLayout="column" fxLayoutGap="16px">
    <h1 mat-dialog-title>{{ (editMode ? 'global.edit_service_number' : 'global.add_service_number') | translate }}</h1>
    <mat-form-field>
      <input
        matInput
        placeholder="{{ 'global.company_id' | translate }}"
        [(ngModel)]="service.organization"
        name="id"
        [disabled]="editMode"
        required
        gtAlphanumericValidator
        gtMaxCharactersValidator
        #id="ngModel"
      />
      <mat-error>{{ id.errors?.message | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="{{ 'global.service_number' | translate }}"
        [(ngModel)]="service.number"
        name="number"
        [disabled]="editMode"
        gtPhoneNumberValidator
        #number="ngModel"
      />
      <mat-hint>{{ 'global.service_number_number_hint' | translate }}</mat-hint>
      <mat-error>{{ number.errors?.message | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'global.service_number_pattern' | translate }}</mat-label>
      <mat-select [(ngModel)]="service.pattern" name="pattern" [disabled]="editMode" required #selector="ngModel">
        <mat-option *ngFor="let serviceTemplate of supportedPatterns" [value]="serviceTemplate">
          {{ serviceTemplate | servicePattern }}
        </mat-option>
      </mat-select>
      <mat-error>{{ selector.errors?.message | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        placeholder="{{ 'global.service_number_name' | translate }}"
        [(ngModel)]="service.name"
        name="name"
        required
        gtAlphanumericValidator
        #name="ngModel"
      />
      <mat-error>{{ name.errors?.message | translate }}</mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutGap="5px">
      <button mat-button (click)="onCancelClick()" color="primary" class="btn btn-default">
        {{ 'global.cancel' | translate }}
      </button>
      <button mat-raised-button (click)="onSaveClick()" color="primary" class="btn btn-default" [disabled]="f.invalid">
        {{ 'global.save' | translate }}
      </button>
    </div>
  </div>
</form>
